import { requestGet } from '@/common/request';

export interface uploadParams {
  fileName: string;
}

export interface uploadRes {
  ret: string;
  msg: string;
  data: {
    fileName: string;
    downloadUrl: string;
    successCount: number;
    failCount: number;
  };
}

//
export async function upload(params: uploadParams): Promise<uploadRes> {
  return await requestGet('/channelActivity/upload', params);
}
